import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { RouteLevelContext } from './context.js';
import { useMatchingRouteForPath } from './hooks.js';
import { RouteRenderer } from './Route.js';
export function Outlet({ children }) {
    var _a, _b;
    const { match: parent, params: upstreamParams } = useContext(RouteLevelContext);
    const match = useMatchingRouteForPath((_a = parent === null || parent === void 0 ? void 0 : parent.remainingPath) !== null && _a !== void 0 ? _a : '', (_b = parent === null || parent === void 0 ? void 0 : parent.route.children) !== null && _b !== void 0 ? _b : null);
    if (children) {
        return children(match, upstreamParams);
    }
    if (!match)
        return null;
    return _jsx(RouteRenderer, { value: match, params: upstreamParams });
}
//# sourceMappingURL=Outlet.js.map